module.exports = __webpack_public_path__ + "static/mindful-0c554afe76d9d4a8a3c263b7c5912b4f.jpg";